import SwiperController from "./components/previews/swiper";
import './components/pager';
import EventBus from "./events/EventBus";
const swiper = new SwiperController('.prod-teaser', window.devicePixelRatio);
document.addEventListener('DOMContentLoaded', () => setTimeout(() => swiper.update()));
EventBus.on('products:load', () => swiper.update());
EventBus.on('products:unload', () => swiper.destroy());
